import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 33 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .25,
		width: 32,
		height: 32,
		rx: "var(--icon-button-radius, 10)",
		fill: "var(--add-button-bg, #79FBAF)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.8863 12.25C16.8863 11.8358 16.5505 11.5 16.1363 11.5C15.7221 11.5 15.3863 11.8358 15.3863 12.25V13.9773V15.3001H14.1529H12.5C12.0858 15.3001 11.75 15.6358 11.75 16.0501C11.75 16.4643 12.0858 16.8001 12.5 16.8001H14.1529H15.3863V18.1227V19.85C15.3863 20.2642 15.7221 20.6 16.1363 20.6C16.5505 20.6 16.8863 20.2642 16.8863 19.85V18.1227V16.8001H18.1198H19.7727C20.1869 16.8001 20.5227 16.4643 20.5227 16.0501C20.5227 15.6358 20.1869 15.3001 19.7727 15.3001H18.1198H16.8863V13.9773V12.25Z",
		fill: "var(--add-button-color, #130F26)"
	})]
});
export default SvgAddIcon;
